export function reportError(error) {
	// TODO: Report to external error reporting API, like sentry
	console.warn(error);
}
